export const UNIT_OF_DISTANCE = {
  KILOMETERS: 'km',
  MILES: 'mi'
};
